<template>
    <v-card ref="card" class="flex-shrink-0" outlined>
        <v-card-title style="border-bottom: 1px solid #404040" class="pt-1">
            <div
                class="text-left"
                style="
                    margin-left: 0;
                    width: 50%;
                    font-size: 13px;
                    font-weight: normal;
                "
            >
                {{ $t("monitor.allBook.title") }}
            </div>
            <div class="text-right" style="margin-right: 0; width: 50%">
                <span id="allBookFunction">
                    <v-tooltip top v-if="showLPIcon">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                dark
                                v-bind="attrs"
                                v-on="on"
                                color="orange"
                                class="mr-1"
                                @click="lpAllBookDialog = true"
                                >mdi-sigma</v-icon
                            >
                        </template>
                        <span>{{ $t("monitor.allBook.lpVsBook") }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="loadDailySummaryIcon === 1">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                dark
                                v-bind="attrs"
                                v-on="on"
                                color="primary"
                                class="mr-1"
                                @click="dailySummaryDialog = true"
                                >mdi-text-box</v-icon
                            >
                        </template>
                        <span>{{
                            $t("monitor.allBook.dailySummaryHistory")
                        }}</span>
                    </v-tooltip>
                    <!-- CSV导出 -->
                    <download-excel
                        :data="briefData"
                        :fields="allBookCsvFields"
                        style="display: inline"
                        :name="$t('monitor.allBook.title') + '.csv'"
                        :escapeCsv="false"
                        type="csv"
                        v-if="!VUETIFY_BREAKPOINT.mobile"
                    >
                        <v-icon color="green" dark style="cursor: pointer">
                            mdi-microsoft-excel
                        </v-icon>
                    </download-excel>
                    <v-menu offset-y dense>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                small
                                color="default"
                                dark
                                v-bind="attrs"
                                v-on="on"
                                class="ml-1"
                                style="height: 19px"
                            >
                                {{
                                    allBookIntervalOptions.find(
                                        (option) =>
                                            option.value === selectedInterval
                                    ).key
                                }}
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item
                                v-for="item in allBookIntervalOptions"
                                :key="item.key"
                                @click="UPDATE_SELECTED_INTERVAL(item.value)"
                            >
                                <v-list-item-title>{{
                                    item.key
                                }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </span>
            </div>
        </v-card-title>

        <v-data-table
            dense
            :headers="briefHeader"
            :items="computedVisibleData"
            item-key="book"
            :hide-default-footer="true"
            :mobile-breakpoint="0"
            class="elevation-1 fix-first-col"
            :height="tableHeight"
            :items-per-page="-1"
            :header-props="{ sortIcon: null }"
            fixed-header
        >
            <template v-slot:header.NPNL="{ header }">
                <span style="min-width: 50px">
                    {{ header.text }}
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="grey"
                                size="14"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>{{ $t("monitor.allBook.NPNL") }}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:header.CPNL="{ header }">
                <span style="min-width: 50px">
                    {{ header.text }}
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="grey"
                                size="14"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>{{ $t("monitor.allBook.CPNL") }}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:header.FPNL="{ header }">
                <span style="min-width: 50px">
                    {{ header.text }}
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="grey"
                                size="14"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>{{ $t("monitor.allBook.FPNL") }}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:header.mtdPnl="{ header }">
                <span style="min-width: 70px">
                    {{ header.text }}
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="grey"
                                size="14"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>{{ $t("monitor.allBook.mtdPnl") }}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:header.mtdVol="{ header }">
                <span style="min-width: 70px">
                    {{ header.text }}
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                color="grey"
                                size="14"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                mdi-information
                            </v-icon>
                        </template>
                        <span>{{ $t("monitor.allBook.mtdVol") }}</span>
                    </v-tooltip>
                </span>
            </template>

            <template v-slot:item="{ item }">
                <tr @click="rowClicked(item)">
                    <td :style="`padding-left: ${8 + item.depth * 20}px`">
                        <v-icon
                            x-small
                            v-if="item.hasChildren"
                            style="cursor: pointer"
                        >
                            {{
                                expanded.includes(item.book)
                                    ? "mdi-chevron-down"
                                    : "mdi-chevron-right"
                            }}
                        </v-icon>
                        <v-icon x-small v-else style="visibility: hidden"
                            >mdi-chevron-right</v-icon
                        >
                        <a v-on:click.stop="changeBook(item.book)">{{
                            item.book
                        }}</a>
                    </td>
                    <td align="right">
                        <div :style="'backgroundColor:' + item.color">
                            {{
                                numberWithCommas(
                                    parseFloat(item.NPNL).toFixed(2)
                                )
                            }}
                        </div>
                    </td>
                    <td align="right">
                        <div :style="'backgroundColor:' + item.closedColor">
                            {{
                                numberWithCommas(
                                    parseFloat(item.CPNL).toFixed(2)
                                )
                            }}
                        </div>
                    </td>
                    <td align="right">
                        {{ numberWithCommas(parseFloat(item.FPNL).toFixed(2)) }}
                    </td>
                    <td align="right">
                        {{
                            numberWithCommas(
                                parseFloat(item.dailyVolumeUSD).toFixed(2)
                            )
                        }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'NetEquity')
                                .align !== ' d-none'
                        "
                    >
                        {{
                            numberWithCommas(
                                parseFloat(item.NetEquity).toFixed(2)
                            )
                        }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'mtdPnl')
                                .align !== ' d-none'
                        "
                    >
                        {{ outputMtdPnl(item.book) }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'mtdVol')
                                .align !== ' d-none'
                        "
                    >
                        {{ outputMtdVolume(item.book) }}
                    </td>
                </tr>
            </template>

            <template v-slot:body.append>
                <tr class="summary-row">
                    <td>
                        <strong>{{ $t("monitor.allBook.total") }}</strong>
                    </td>
                    <td align="right">
                        {{ numberWithCommas(totalNPNL.toFixed(2)) }}
                    </td>
                    <td align="right">
                        {{ numberWithCommas(totalCPNL.toFixed(2)) }}
                    </td>
                    <td align="right">
                        {{ numberWithCommas(totalFPNL.toFixed(2)) }}
                    </td>
                    <td align="right">
                        {{ numberWithCommas(totalDailyVolumeUSD.toFixed(2)) }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'NetEquity')
                                .align !== ' d-none'
                        "
                    >
                        {{ numberWithCommas(totalNetEquity.toFixed(2)) }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'mtdPnl')
                                .align !== ' d-none'
                        "
                    >
                        {{ numberWithCommas(totalMtdPnl.toFixed(2)) }}
                    </td>
                    <td
                        align="right"
                        v-if="
                            briefHeader.find((h) => h.value === 'mtdVol')
                                .align !== ' d-none'
                        "
                    >
                        {{ numberWithCommas(totalMtdVol.toFixed(2)) }}
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-dialog
            v-model="dailySummaryDialog"
            width="600"
            :persistent="true"
            style="overflow: hidden"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        {{ $t("monitor.allBook.dailySummaryHistory") }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-icon
                        :disabled="
                            dailySummaryTableData.length === 0 ? true : false
                        "
                        color="green"
                        @click="onDailySummaryDataDownload"
                    >
                        mdi-microsoft-excel
                    </v-icon>

                    <download-excel
                        :escapeCsv="false"
                        id="dailySummaryDownload"
                        style="display: none"
                        :data="dailySummaryTableData"
                        :fields="downloadFields"
                        type="csv"
                        :name="
                            $t('monitor.allBook.dailySummaryHistory') + '.csv'
                        "
                    />

                    <v-btn
                        color="white"
                        icon
                        @click="dailySummaryDialog = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-card-actions class="pt-0">
                    <v-row>
                        <v-col cols="3" class="pb-0 pt-0">
                            <v-menu
                                v-model="dateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="selectedDailySummaryDate"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        hide-details
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="selectedDailySummaryDate"
                                    @input="dateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="1" class="pb-0 pl-0 pt-4">
                            <v-btn
                                :loading="loading"
                                fab
                                x-small
                                color="primary"
                                shape="circle"
                                @click="fetchDailySummary"
                            >
                                <v-icon>mdi-magnify</v-icon>
                            </v-btn>
                        </v-col>

                        <v-col cols="12"
                            ><v-data-table
                                dense
                                :loading="loading"
                                :headers="dailySummaryTableHeader"
                                :items="dailySummaryTableData"
                                :header-props="{ sortIcon: null }"
                                item-key="id"
                                class="elevation-0 flex-grow-1"
                                :items-per-page="25"
                                id="daily-summary-table"
                                fixed-header
                                :footer-props="{
                                    'items-per-page-text': $t(
                                        'common.table.rowsPerPage'
                                    ),
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="lpAllBookDialog"
            width="500"
            :persistent="true"
            class="no-scroll-dialog"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">
                        {{ $t("common.table.netEquity") }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="white"
                        icon
                        @click="lpAllBookDialog = false"
                        :loading="lpInformationLoading"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-card-actions class="pt-0">
                    <v-row>
                        <v-col cols="12">
                            <div class="text-body-1 ma-4">
                                <table class="equity-table">
                                    <tr>
                                        <td>LP:</td>
                                        <td class="text-right">
                                            ${{
                                                numberWithCommas(
                                                    lpInformation[
                                                        "netEquity"
                                                    ].toFixed(2)
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Books(B+S):</td>
                                        <td class="text-right">
                                            ${{
                                                numberWithCommas(
                                                    totalSpecifiedBookNetEquity.toFixed(
                                                        2
                                                    )
                                                )
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{ $t("common.word.difference") }}:
                                        </td>
                                        <td class="text-right">
                                            ${{
                                                numberWithCommas(
                                                    (
                                                        lpInformation[
                                                            "netEquity"
                                                        ] -
                                                        totalSpecifiedBookNetEquity
                                                    ).toFixed(2)
                                                )
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { helper } from "@components/mixins/helper";
import { permission } from "@components/mixins/permission";
import { getDailySummary } from "@services/statistic/daily-summary";
import { snackbar } from "@components/mixins/snackbar";
import { getLPAccount } from "@services/lp/account";

export default {
    data() {
        return {
            expanded: [],
            isWatching: true,
            dateMenu: false,
            showLPIcon: false,
            lpAllBookDialog: false,
            downloadFields: {
                Book: "book",
                "Close PNL EOD": "total_close_pnl_at_eod",
                "Net PNL EOD": "total_net_pnl_at_eod",
                "Open PNL EOD": "total_open_pnl_at_eod",
            },
            loadDailySummaryIcon: 0,
            selectedDailySummaryDate: null,
            dailySummaryDialog: false,
            dailySummaryTableHeader: [
                { text: "Book", value: "book", width: 30, align: "left" },
                {
                    text: this.$t("common.table.closePnlEod"),
                    value: "total_close_pnl_at_eod",
                    width: 60,
                    align: "right",
                },
                {
                    text: this.$t("common.table.netPnlEod"),
                    value: "total_net_pnl_at_eod",
                    width: 60,
                    align: "right",
                },
                {
                    text: this.$t("common.table.openPnlEod"),
                    value: "total_open_pnl_at_eod",
                    width: 60,
                    align: "right",
                },
            ],
            dailySummaryTableData: [],
            loading: false,
            lpInformation: {
                netEquity: 0,
            },
            lpInformationLoading: false,
        };
    },
    mixins: [helper, permission, snackbar],
    props: {
        mtdPnl: null,
        mtdVolume: null,
        tableHeight: Number,
    },
    computed: {
        ...mapState("Home", [
            "briefHeader",
            "briefData",
            "allBookCsvFields",
            "books",
            "allBookIntervalOptions",
            "selectedInterval",
        ]),
        computedVisibleData() {
            if (!this.briefData) return [];
            return this.briefData.filter((item) => {
                if (item.depth === 0) return true;
                let current = item;
                while (current.parentBook) {
                    if (!this.expanded.includes(current.parentBook))
                        return false;
                    current = this.briefData.find(
                        (b) => b.book === current.parentBook
                    );
                    if (!current) return false;
                }
                return true;
            });
        },
        topLevelData() {
            if (!this.briefData) return [];
            return this.briefData.filter((item) => item.depth === 0);
        },
        totalNPNL() {
            return this.topLevelData.reduce(
                (sum, row) => sum + parseFloat(row.NPNL || 0),
                0
            );
        },
        totalCPNL() {
            return this.topLevelData.reduce(
                (sum, row) => sum + parseFloat(row.CPNL || 0),
                0
            );
        },
        totalFPNL() {
            return this.topLevelData.reduce(
                (sum, row) => sum + parseFloat(row.FPNL || 0),
                0
            );
        },
        totalDailyVolumeUSD() {
            return this.topLevelData.reduce(
                (sum, row) => sum + parseFloat(row.dailyVolumeUSD || 0),
                0
            );
        },
        totalNetEquity() {
            return this.topLevelData.reduce(
                (sum, row) => sum + parseFloat(row.NetEquity || 0),
                0
            );
        },
        totalSpecifiedBookNetEquity() {
            const specifiedBooks = ["B", "S"];
            return this.topLevelData.reduce(
                (sum, row) =>
                    sum +
                    parseFloat(
                        specifiedBooks.includes(row.book) ? row.NetEquity : 0
                    ),
                0
            );
        },
        totalMtdPnl() {
            return this.topLevelData.reduce(
                (sum, row) =>
                    sum + parseFloat(this.outputMtdPnl(row.book) || 0),
                0
            );
        },
        totalMtdVol() {
            return this.topLevelData.reduce(
                (sum, row) =>
                    sum + parseFloat(this.outputMtdVolume(row.book) || 0),
                0
            );
        },
    },
    watch: {
        lpAllBookDialog(nv) {
            if (nv) {
                this.fetchLpAccountInfo();
            } else {
                this.lpInformation = {
                    netEquity: 0,
                };
            }
        },
    },
    methods: {
        ...mapMutations("Home", [
            "UPDATE_ALL_BOOK_HEADER",
            "UPDATE_SELECTED_INTERVAL",
        ]),
        outputMtdPnl(book) {
            const data = this.mtdPnl.filter((item) => item.book === book);
            if (data.length !== 0) {
                let isPos = true;
                let returnString = null;
                if (data[0].mtd_pnl < 0) {
                    isPos = false;
                }
                if (data[0].mtd_pnl === null) {
                    return 0;
                }
                if (Math.abs(data[0].mtd_pnl) >= 1000000000) {
                    returnString =
                        (Math.abs(data[0].mtd_pnl) / 1000000000)
                            .toFixed(2)
                            .toString() + " B";
                } else if (Math.abs(data[0].mtd_pnl) >= 1000000) {
                    returnString =
                        (Math.abs(data[0].mtd_pnl) / 1000000)
                            .toFixed(2)
                            .toString() + " M";
                } else if (Math.abs(data[0].mtd_pnl) >= 1000) {
                    returnString =
                        (Math.abs(data[0].mtd_pnl) / 1000)
                            .toFixed(2)
                            .toString() + " K";
                } else {
                    returnString = Math.abs(data[0].mtd_pnl)
                        .toFixed(2)
                        .toString();
                }
                return isPos ? returnString : "-" + returnString;
            }
            return 0;
        },
        outputMtdVolume(book) {
            const data = this.mtdVolume.filter((item) => item.book === book);
            if (data.length !== 0) {
                let isPos = true;
                let returnString = null;
                if (data[0].mtd_vol === null) {
                    return 0;
                }
                if (data[0].mtd_vol < 0) {
                    isPos = false;
                }
                if (Math.abs(data[0].mtd_vol) >= 1000000000) {
                    returnString =
                        (Math.abs(data[0].mtd_vol) / 1000000000)
                            .toFixed(2)
                            .toString() + " B";
                } else if (Math.abs(data[0].mtd_vol) >= 1000000) {
                    returnString =
                        (Math.abs(data[0].mtd_vol) / 1000000)
                            .toFixed(2)
                            .toString() + " M";
                } else if (Math.abs(data[0].mtd_vol) >= 1000) {
                    returnString =
                        (Math.abs(data[0].mtd_vol) / 1000)
                            .toFixed(2)
                            .toString() + " K";
                } else {
                    returnString = Math.abs(data[0].mtd_vol)
                        .toFixed(2)
                        .toString();
                }
                return isPos ? returnString : "-" + returnString;
            }
            return 0;
        },
        changeBook(book) {
            this.$emit("changeBook", book);
        },
        getAllDescendants(bookName) {
            const result = new Set([bookName]);
            const children = this.briefData.filter(
                (b) => b.parentBook === bookName
            );
            for (const child of children) {
                this.getAllDescendants(child.book).forEach((b) =>
                    result.add(b)
                );
            }
            return result;
        },
        rowClicked(item) {
            if (!item.hasChildren) return;
            if (this.expanded.includes(item.book)) {
                const toRemove = this.getAllDescendants(item.book);
                this.expanded = this.expanded.filter((b) => !toRemove.has(b));
            } else {
                this.expanded = [...this.expanded, item.book];
            }
        },
        fetchDailySummary() {
            this.loading = true;
            getDailySummary({ date: this.selectedDailySummaryDate })
                .then((res) => {
                    this.snackBarSuccess(
                        this.$t("message.dailySummarySuccess")
                    );
                    const { data } = res;
                    this.dailySummaryTableData = data;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.snackBarDanger(this.$t("message.somethingWentWrong"));
                    this.loading = false;
                });
        },
        onDailySummaryDataDownload() {
            document.getElementById("dailySummaryDownload").click();
        },
        fetchLpAccountInfo() {
            this.lpInformationLoading = true;
            getLPAccount()
                .then((res) => {
                    const totalEquity = res.data.reduce(
                        (sum, item) => sum + item.Equity - item.Credit,
                        0
                    );
                    this.lpInformation = {
                        netEquity: totalEquity,
                    };
                })
                .finally(() => {
                    this.lpInformationLoading = false;
                });
        },
    },
    created() {
        const userFunction = this.getFunction("book");

        if (userFunction.includes("mtdVolumeColumn")) {
            this.UPDATE_ALL_BOOK_HEADER({ target: "mtdVol", alignment: "end" });
        } else {
            this.UPDATE_ALL_BOOK_HEADER({
                target: "mtdVol",
                alignment: " d-none",
            });
        }
        if (userFunction.includes("mtdPnlColumn")) {
            this.UPDATE_ALL_BOOK_HEADER({ target: "mtdPnl", alignment: "end" });
        } else {
            this.UPDATE_ALL_BOOK_HEADER({
                target: "mtdPnl",
                alignment: " d-none",
            });
        }
        if (userFunction.includes("netEquityColumn")) {
            this.showLPIcon = true;
            this.UPDATE_ALL_BOOK_HEADER({
                target: "NetEquity",
                alignment: "end",
            });
        } else {
            this.UPDATE_ALL_BOOK_HEADER({
                target: "NetEquity",
                alignment: " d-none",
            });
        }
        this.isWatching = true;
        this.unwatchIsLiveProp = this.$watch("briefData", (nv) => {
            if (nv) {
                nv.forEach((item) => {
                    if (
                        item.hasChildren &&
                        !this.expanded.includes(item.book)
                    ) {
                        this.expanded = [...this.expanded, item.book];
                    }
                });
                this.unwatchIsLiveProp();
                this.isWatching = false;
            }
        });
        const permission = JSON.parse(
            localStorage.getItem("permission")
        ).frontPermission;
        if (!Object.prototype.hasOwnProperty.call(permission, "alert")) {
            this.loadRing = false;
        }

        if (permission.book.function.includes("dailySummaryIcon")) {
            this.loadDailySummaryIcon = 1;
        }
        const today = new Date();
        today.setDate(today.getDate() - 1);

        this.selectedDailySummaryDate = today.toISOString().slice(0, 10);
    },
};
</script>
<style lang="scss" scoped>
.v-data-table .summary-row td {
    border-top: 2px solid #494949;
}

::v-deep(.v-data-table .summary-row) {
    position: sticky;
    bottom: 0;
    background-color: #1e1e1e;
    z-index: 5;
}
::v-deep(.v-dialog) {
    overflow-y: hidden !important;
}
.equity-table {
    width: 100%;
    border-collapse: collapse;
}

.equity-table td {
    padding: 4px 0;
}

.equity-table td:first-child {
    font-weight: 500;
    color: #ccc;
}

.equity-table td:last-child {
    font-weight: 600;
}
</style>
